import { SimpleGrid, Tab, TabList, TabPanel, TabPanels, Tabs, Heading, Box } from '@chakra-ui/react';
import React from 'react';
import { AppState } from '../Context/AppProvider';
import Card from './Components/Card';
import SEO from '../Components/SEO';

export default function Women() {
  let {data}= AppState();
  return (
    <>
        <SEO
          title="Women's Clothing & Ethnic Collections - Ajanta Cloth House, Sirsa"
          description="Elegant kurtis, dresses and ethnic wear for women. Curated collections from trusted brands at Ajanta Cloth House in Sirsa."
          path="/women"
          image="https://ajantasirsa.com/og-image.png"
        />
        <Box px={6} pt={6}>
          <Heading as="h1" size="lg" color="#2c7a7b" mb={4} fontWeight="semibold">
            Women's Collections - Elegant Everyday & Festive Wear
          </Heading>
          <Box maxW={{base:'95%',md:'70%'}} color="#333" mb={6}>
            <p>
              Discover women's attire, from hand-stitched kurtis to festive ensembles. We select comfortable fabrics and refined styles from trusted brands and exclusive picks. Our team helps with styling and sizing. Explore the latest arrivals online or contact us about availability before your visit.
            </p>
          </Box>
        </Box>
        <Tabs isFitted variant='enclosed' p={3} colorScheme='teal'>
          <TabList mb='1em'>
            <Tab>Ajanta Cloth House</Tab>
            <Tab>Ajanta Collections</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <SimpleGrid 
                minChildWidth={{base:"150px",sm:"200px",md:"300px"}} 
                mt={1} ml={"1%"} rowGap={8} 
              >
                
                {/* Items */}
                {
                Array.isArray(data) && data.map((element,id) => {
                  return(
                    (String(element.category || '').trim().toLowerCase()==="women" && element.tab !== null && Number(element.tab)===0)?
                    <React.Fragment key= {id}>
                      <Card
                        src={element.image}
                        title={element.title}
                        alt={element.alt}
                        desc={element.description}
                      />
                    </React.Fragment>
                    :
                    <React.Fragment key= {id}></React.Fragment>
                  )
                })
              }
                
              </SimpleGrid> 
            </TabPanel>
            <TabPanel>
              <SimpleGrid 
                minChildWidth={{base:"150px",sm:"200px",md:"300px"}} 
                mt={1} ml={"1%"} rowGap={8} 
              >
                
                {/* Items */}
                {
                Array.isArray(data) && data.map((element,id) => {
                  return(
                    ((element.tab===null || Number(element.tab)===1) && String(element.category || '').toLowerCase()==="women")?
                    <React.Fragment key= {id} >
                      <Card
                        src={element.image}
                        title={element.title}
                        alt={element.alt}
                        desc={element.description}
                      />
                    </React.Fragment>
                    :
                    <React.Fragment key= {id}></React.Fragment>
                  )
                })
              }
                
              </SimpleGrid> 
            </TabPanel>
          </TabPanels>
        </Tabs>
    </>
  )
}
